import { ConfigFn } from '@config/types'

const API_VERSION = 'latest'

const config = (({
  useLocalhostApiUrl,
  publication,
  apiUrl,
  imageUrl,
  baseUrl,
  cueLiveUrl,
  deploymentEnv,
  teamcityEnv,
  hotModuleReloading,
  releaseVersion,
  apiEnvironment,
}) => {
  const versionedApiUrl = `${
    useLocalhostApiUrl
      ? (`http://localhost:8101/${
          publication === 'romandie' ? 'romandie' : 'blick'
        }` as const)
      : (`${apiUrl}/${API_VERSION}` as const)
  }` as const

  const cueLiveEventBaseUrl = `${cueLiveUrl}/entries/` as const

  const processedReleaseVersion =
    teamcityEnv !== 'prod' ? releaseVersion.slice(0, 7) : releaseVersion

  return {
    useLocalhostApiUrl,
    deploymentEnv,
    teamcityEnv,
    hotModuleReloading,
    imageUrl,
    apiUrl,
    apiEnvironment,
    versionedApiUrl,
    skeletonUrl: `${versionedApiUrl}${
      publication === 'romandie' && !useLocalhostApiUrl ? '/fr' : ''
    }/skeleton-web/`,
    rootUrl: `/${publication === 'romandie' ? 'fr/' : ''}`,
    baseUrl,
    cueLiveEventBaseUrl,
    cueLiveTeaserEventBaseUrl: `${cueLiveEventBaseUrl}teasers/`,
    blickReleaseVersion: `next-${teamcityEnv}-${processedReleaseVersion}-${publication}`,
  } as const
}) satisfies ConfigFn

export default config
